/**
 * Constant that holds the keys of modals that may be triggered on the site
 */
export const MODALS = Object.freeze({
  ADDRESS_UPDATE_ERROR: 'ADDRESS_UPDATE_ERROR',
  ADDRESS_VALIDATION: 'ADDRESS_VALIDATION',
  BUY_EDIT_ORDER_ERROR_MODAL: 'BUY_EDIT_ORDER_ERROR_MODAL',
  CHECKOUT_ERROR: 'CHECKOUT_ERROR_MODAL',
  CHECKOUT_PROMPT: 'CHECKOUT_PROMPT_MODAL',
  DOUBLE_CONFIRM: 'DOUBLE_CONFIRM_MODAL',
  SUCCESS_MODAL: 'SUCCESS_MODAL',
  CUSTOMER_CARE_TICKET_MODAL: 'CUSTOMER_CARE_TICKET_MODAL',
  ERROR_MODAL: 'ERROR_MODAL',
  ERROR_HELP_CENTER_MODAL: 'ERROR_HELP_CENTER_MODAL',
  EVENT_MGR_CANCEL_PARTICIPANT: 'EVENT_MGR_CANCEL_PARTICIPANT_MODAL',
  FIT_ERROR_MODAL: 'FIT_ERROR_MODAL',
  FIT_GUARANTEE: 'FIT_GUARANTEE_MODAL',
  FUNCTIONAL_RULE: 'FUNCTIONAL_RULE_MODAL',
  LOOKBUILDER_REMOVE_ITEM: 'LOOKBUILDER_REMOVE_ITEM_MODAL',
  LOOKBUILDER_RENT_OR_BUY: 'LOOKBUILDER_RENT_OR_BUY_MODAL',
  PARTICIPANT_PERMISSION_MODAL: 'PARTICIPANT_PERMISSION_MODAL',
  PDP_ERROR: 'PDP_ERROR_MODAL',
  PRINT_RETURN_LABEL: 'PRINT_RETURN_LABEL_MODAL',
  RECOMMENDATION_MODAL: 'RECOMMENDATION_MODAL',
  RENT_VS_BUY: 'RENT_VS_BUY_MODAL',
  RTK_CHECKOUT_ERROR: 'RTK_CHECKOUT_ERROR_MODAL',
  TIME_TO_EVENT_ERROR_MODAL: 'TIME_TO_EVENT_ERROR_MODAL',
})

export type ModalType = typeof MODALS[keyof typeof MODALS]
